<template>
  <div class="featured-project" :class="{ odd: isOdd }" v-if="project">
    <figure v-for="(image, index) in project.acf.gallerie_page_daccueil" :key="index">
      <img :src="image.sizes.large" alt="">
      <figcaption v-if="index === 1">
        <p class="smalltxt">{{ project.acf.texte_page_daccueil }}</p>
        <router-link :to="slugExtraction(project)" class="smalltxt">
          <strong>{{ $t('voir-le-projet') }} →</strong>
        </router-link>
      </figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'FeaturedProject',
  props: {
    project: {
      type: Object,
      required: true,
    },
    isOdd: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    slugExtraction(item) {
      return `/projets/${item.slug}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
</style>



// WEBPACK FOOTER //
// src/components/Modules/FeaturedProject.vue